import React from "react";
import {
  Card as MuiCard,
  Box as MuiBox,
  Typography as MuiTypography,
  CardContent as MuiCardContent,
} from "@mui/material";
import PropTypes from "prop-types";
import SectionIcon from "./SectionIcon";
import ContextualHelp from "../../../shared/UI/ContextualHelp";

const InfoCard = (props) => {
  const {
    iconComponent,
    title,
    titleVariant: variant,
    helpText,
    slotProps,
    children,
  } = props;

  const hasHeader = iconComponent || title || helpText;
  const IconComponent = iconComponent || "div";

  const insightCardSx = {
    borderRadius: "16px",
    border: "1px solid #E0E0E0",
    boxShadow: "none",
    minHeight: 100,
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "18px 24px",
    height: "100%",
  };

  const titleVariants = {
    default: {
      fontSize: 24,
    },
    small: {
      fontSize: 18,
    },
  };

  return (
    <MuiCard sx={insightCardSx}>
      {hasHeader && (
        <MuiBox
          spacing={4}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
            columnGap: 2,
            marginBottom: 2,
            ...slotProps?.header,
          }}
        >
          {iconComponent && <SectionIcon icon={IconComponent} />}
          <MuiTypography
            variant="h6"
            mb={4}
            sx={{
              marginBottom: 0,
              ...titleVariants[variant || "default"],
              ...slotProps?.title,
            }}
          >
            {title}
          </MuiTypography>
          {helpText && (
            <ContextualHelp
              helpText={helpText}
              sx={{ marginLeft: "auto", ...slotProps?.help }}
            />
          )}
        </MuiBox>
      )}
      <MuiCardContent
        sx={{
          width: "100%",
          padding: 0,
          "&:last-child": { paddingBottom: 0 },
          ...slotProps?.content,
        }}
      >
        {children}
      </MuiCardContent>
    </MuiCard>
  );
};

InfoCard.propTypes = {
  helpText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleVariant: PropTypes.string,
  iconComponent: PropTypes.elementType,
  slotProps: PropTypes.object,
  children: PropTypes.node,
};

export default InfoCard;
